<script>
    import AppMixin from 'keysso/mixins/AppMixin'
    import {Listeners} from "keysso/constants/listeners";
    import AdaptersDialog from "keysso/component/adapters/Dialog.vue";
    import AdaptersMessage from "keysso/component/adapters/Message.vue";
    import {store} from "../store";
    import Checkbox from "primevue/checkbox";
    import Button from "primevue/button";
    import ClusterApi from "keysso/api/ClusterApi";
    import Alerts from "keysso/mixins/Alerts";
    import TariffAPI from "keysso/api/TariffAPI";
    import {FormatHelper} from "keysso/helpers/FormatHelper";
    import {ProjectsConstants} from "../../wordstat/constants/projectConstants";
    import {AppConstant} from "../../../app.constant";

    export default {
        name: "KSUpdateFrequency",
        mixins: [AppMixin, Alerts],
        props: {
            isDemo: {
                type: Boolean,
                required: false,
                default: false,
            },
        },
        data() {
            return {
                loading: false,
                polling: false,
                error: null,
                loadedLimit: false,
                limits: {
                    wordstatPerMonth: {limit: 0, usedLimit: 0},
                },
                totalKeys: 0,
                model: {
                    frequency: {
                        [ProjectsConstants.FREQUENCY_TYPE_WS]: true,
                        [ProjectsConstants.FREQUENCY_TYPE_WSK]: false,
                        [ProjectsConstants.FREQUENCY_TYPE_SWSK]: false,
                    },
                },
                store: store,
            }
        },
        methods: {
            doUpdateFrequency() {
                if (this.isDisabledStartByLimits || this.getFrequency.length === 0) {
                    this.alertError(this.$t('lang.cluster.update_parser_limits_error'));
                    return;
                }
                if (this.isDemo) {
                    this.alertError(this.$t('lang.cluster.auto_cls_demo_block'));
                    return;
                }

                this.loading = true;
                ClusterApi
                    .updateFrequency(this.getUid, {ws_types: this.getFrequency})
                    .then(() => {
                        this.polling = true;
                        this.pollParsersState();
                    })
                    .catch(error => {
                        this.alertError(error.message);
                        this.loading = false;
                    });
            },
            // пока идёт сбор частотности, попап не закрываем и опрашиваем статус парсинга,
            // т.к. cluster.state не меняется (кластеризация не запускается) и обычный
            // reload() не покажет лоадер страницы (ks-cluster-page-waiter завязан на state)
            pollParsersState() {
                ClusterApi
                    .getParsersState(this.getUid)
                    .then(response => {
                        if (response.batches_total === 0) {
                            window.location.reload();
                            return;
                        }

                        setTimeout(() => this.pollParsersState(), AppConstant.TIMEOUT_WAITER_REQUEST);
                    })
                    .catch(error => {
                        this.alertError(error.message);
                        this.polling = false;
                        this.loading = false;
                    });
            },
            onOpen() {
                // если сбор частотности уже идёт (например, попап был закрыт или страница
                // перезагружена во время ожидания) — сразу показываем прогресс, а не форму
                ClusterApi
                    .getParsersState(this.getUid)
                    .then(response => {
                        if (response.batches_total !== 0) {
                            this.loading = true;
                            this.polling = true;
                            this.pollParsersState();
                            return;
                        }

                        this.getLimits();
                        this.getTotalKeys();
                    })
                    .catch(error => this.alertError(error.message));
                this.$emitter.emit(this.getListenerId);
            },
            onClose() {
                if (this.polling) {
                    // сбор частотности продолжается в фоне, попап можно закрыть без отмены процесса
                    this.polling = false;
                    this.loading = false;
                }
                this.error = null;
                this.$emitter.emit(this.getListenerCloseId);
            },
            getLimits() {
                if (this.loadedLimit) {
                    return;
                }
                this.loading = true;
                TariffAPI
                    .getLimits()
                    .then(response => {
                        this.limits.wordstatPerMonth = response.wordstat.perMonth;
                        this.loadedLimit = true;
                    })
                    .finally(() => this.loading = false);
            },
            getTotalKeys() {
                this.loading = true;
                ClusterApi
                    .getCountKeywordsWithoutDeletedArt(this.getUid)
                    .then(response => this.totalKeys = response.count)
                    .finally(() => this.loading = false);
            },
        },
        computed: {
            ProjectsConstants() {
                return ProjectsConstants;
            },
            getUid() {
                return this.store.getters.uid();
            },
            getListenerId() {
                return Listeners.UPDATE_FREQUENCY_POPUP_OPEN;
            },
            getListenerCloseId() {
                return Listeners.UPDATE_FREQUENCY_POPUP_CLOSE;
            },
            getFrequency() {
                return Object.keys(this.model.frequency).filter(key => this.model.frequency[key]).map(Number);
            },
            getLimitWs() {
                return this.limits.wordstatPerMonth.limit - this.limits.wordstatPerMonth.usedLimit;
            },
            getLimitsUpdateWs() {
                return this.totalKeys * this.getFrequency.length;
            },
            isDisabledStartByLimits() {
                return this.getFrequency.length > 0 && this.getLimitsUpdateWs > this.getLimitWs;
            },
            getLimitsUpdateHtml() {
                if (this.getFrequency.length === 0) {
                    return '';
                }

                const formattedValue = FormatHelper.numberWithZero(this.getLimitsUpdateWs);
                const valueHtml = this.getLimitsUpdateWs > this.getLimitWs
                    ? '<b class="text-red-500">' + formattedValue + '</b>'
                    : '<b>' + formattedValue + '</b>';

                return this.$t('lang.cluster.update_freq_calc', [valueHtml, FormatHelper.numberWithZero(this.getLimitWs)]);
            },
        },
        components: {
            AdaptersDialog,
            AdaptersMessage,
            Checkbox,
            Button,
        },
    }
</script>
<template>
    <div>
        <Button
            @click="onOpen"
            :label="$t('lang.cluster.update_freq_btn')"
            :title="$t('lang.cluster.update_freq_title')"
            size="small"
            icon="pi pi-sync"
            class="flex w-full sm:w-auto"
            :pt="{
                icon: { class: 'hidden sm:block' }
            }"
        />
        <AdaptersDialog
            :listener-id="getListenerId"
            :listener-close-id="getListenerCloseId"
            :header="$t('lang.cluster.update_freq_setting')"
            :loading="loading"
            :error-message="error"
            :callback-agree="doUpdateFrequency"
            :button-agree-label="$t('lang.main.btn.run')"
            :callback-on-hide="onClose"
            :is-disable-send="isDisabledStartByLimits || isDemo || getFrequency.length === 0 || polling"
        >
            <template #content>
                <template v-if="polling">
                    <span class="block mb-3">{{ $t('lang.cluster.update_freq_progress') }}</span>
                </template>
                <template v-else>
                    <AdaptersMessage v-if="isDemo" severity="error" :message="$t('lang.cluster.auto_cls_demo_block')" />
                    <div class="field mb-0">
                        <label class="required">{{ $t('lang.cluster.label_frequency') }}</label>
                        <div class="formgroup-inline">
                            <div class="field-checkbox">
                                <Checkbox
                                    v-model="model.frequency[ProjectsConstants.FREQUENCY_TYPE_WS]"
                                    binary
                                    inputId="update-freq-ws"
                                />
                                <label for="update-freq-ws">{{ $t('lang.cluster.frequency_ws') }}</label>
                            </div>
                            <div class="field-checkbox">
                                <Checkbox
                                    v-model="model.frequency[ProjectsConstants.FREQUENCY_TYPE_WSK]"
                                    binary
                                    inputId="update-freq-wsk"
                                />
                                <label for="update-freq-wsk">{{ $t('lang.cluster.frequency_wsk') }}</label>
                            </div>
                            <div class="field-checkbox">
                                <Checkbox
                                    v-model="model.frequency[ProjectsConstants.FREQUENCY_TYPE_SWSK]"
                                    binary
                                    inputId="update-freq-swsk"
                                />
                                <label for="update-freq-swsk">{{ $t('lang.cluster.frequency_swsk') }}</label>
                            </div>
                        </div>
                    </div>
                    <span class="block text-xs mb-4" v-html="getLimitsUpdateHtml" />
                </template>
            </template>
        </AdaptersDialog>
    </div>
</template>
